class ProductForm extends HTMLElement {
  constructor() {
    super();

    this.form = this.querySelector('form');
    if (!this.form) return;

    this.form.addEventListener(
      'submit',
      this.onSubmitHandler.bind(this)
    );

    this.cartNotification =
      document.querySelector('cart-notification');

    this.submitting = false;
  }

  async onSubmitHandler(evt) {
    evt.preventDefault();

    if (window.customerWholesaleApproved !== true) {
      window.HiperionWholesale?.openAccessDialog(this.form.querySelector('[type="submit"]'));
      return;
    }

    if (this.submitting) return;

    const submitButton =
      this.form.querySelector('[type="submit"]');

    if (!submitButton || submitButton.disabled) return;

    const formData = new FormData(this.form);
    const variantId = String(formData.get('id') || '');
    const quantity = Number(formData.get('quantity') || 1);

    if (!Number.isSafeInteger(quantity) || quantity < 1) {
      window.alert('Please enter a whole-number quantity of at least 1.');
      return;
    }

    this.submitting = true;
    submitButton.disabled = true;
    submitButton.classList.add('loading');

    const root = window.Shopify?.routes?.root || '/';
    let itemAdded = false;

    try {
      const rule = Array.from(
        this.querySelectorAll(
          '[data-wholesale-quantity-rules] [data-variant-id]'
        )
      ).find((element) => element.dataset.variantId === variantId);

      if (rule) {
        const minimum = Number(rule.dataset.min) || 1;
        const increment = Number(rule.dataset.increment) || 1;
        const maximum = rule.dataset.max
          ? Number(rule.dataset.max)
          : Infinity;

        const cartResponse = await fetch(`${root}cart.js`, {
          headers: { Accept: 'application/json' },
          cache: 'no-store'
        });

        if (!cartResponse.ok) {
          throw new Error(
            'We could not check your cart. Please try again.'
          );
        }

        const cart = await cartResponse.json();

        const alreadyInCart = cart.items.reduce((total, item) => {
          return String(item.variant_id) === variantId
            ? total + item.quantity
            : total;
        }, 0);

        const totalQuantity = alreadyInCart + quantity;

        if (totalQuantity < minimum) {
          const requiredTotal =
            Math.ceil(minimum / increment) * increment;

          const stillNeeded = requiredTotal - alreadyInCart;

          window.alert(
            `Minimum order: ${minimum} units.\n\n` +
            `Already in your cart: ${alreadyInCart}\n` +
            `You selected: ${quantity}\n\n` +
            `Please change the quantity to at least ${stillNeeded}` +
            ` before adding this item.`
          );
          return;
        }

        if (totalQuantity > maximum) {
          const remaining = Math.max(0, maximum - alreadyInCart);

          window.alert(
            `Maximum order: ${maximum} units.\n\n` +
            `Already in your cart: ${alreadyInCart}\n\n` +
            `You can add up to ${remaining} more units.`
          );
          return;
        }

        if (totalQuantity % increment !== 0) {
          window.alert(
            `This item must be ordered in multiples of ${increment}.\n\n` +
            `Already in your cart: ${alreadyInCart}\n` +
            `You selected: ${quantity}\n` +
            `Combined quantity: ${totalQuantity}\n\n` +
            `Please adjust the quantity and try again.`
          );
          return;
        }
      }

this.cartNotification =
  document.querySelector('cart-notification');

const notificationReady =
  this.cartNotification &&
  typeof this.cartNotification.setActiveElement === 'function' &&
  typeof this.cartNotification.getSectionsToRender === 'function' &&
  typeof this.cartNotification.renderContents === 'function';

if (notificationReady) {
  this.cartNotification.setActiveElement(document.activeElement);
}

      const payload = {
        ...JSON.parse(serializeForm(this.form)),
        id: variantId,
        quantity: quantity
      };

if (notificationReady) {
  payload.sections = this.cartNotification
          .getSectionsToRender()
          .map((section) => section.id);

        payload.sections_url = window.location.pathname;
      }

      const response = await fetch(routes.cart_add_url, {
        ...fetchConfig('javascript'),
        body: JSON.stringify(payload)
      });

      const parsedState = await response.json();

      if (!response.ok || parsedState.status) {
        const message =
          parsedState.description || parsedState.message;

        throw new Error(
          typeof message === 'string'
            ? message
            : 'This item could not be added. Check its quantity and availability.'
        );
      }

      itemAdded = true;

if (notificationReady && parsedState.sections) {
        this.cartNotification.renderContents(parsedState);
      } else {
        window.location.assign(`${root}cart`);
      }
    } catch (error) {
      console.error(error);

      if (itemAdded) {
        // Avoid suggesting another submission after a successful add.
        window.location.assign(`${root}cart`);
      } else {
        window.alert(
          error.message || 'Something went wrong. Please try again.'
        );
      }
    } finally {
      this.submitting = false;
      submitButton.classList.remove('loading');
      submitButton.disabled = false;
    }
  }
}

customElements.define('product-form', ProductForm);